// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockQuote_container__jezFr","rating":"BlockQuote_rating__fS9Y8","quote":"BlockQuote_quote__AXbWc","footer":"BlockQuote_footer__cUD8o"};